import { render, staticRenderFns } from "./searchRecipes.vue?vue&type=template&id=bf9b9444&scoped=true"
import script from "./searchRecipes.vue?vue&type=script&lang=js"
export * from "./searchRecipes.vue?vue&type=script&lang=js"
import style0 from "./searchRecipes.vue?vue&type=style&index=0&id=bf9b9444&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b9444",
  null
  
)

export default component.exports